








































import { Component, Vue } from 'vue-property-decorator';
import { State, Action } from 'vuex-class';
import firebase from 'firebase';
import { User } from '@/models/user';

@Component
export default class Users extends Vue {
    @Action('getCurrentUser') private getCurrentUserAction: any;
    @State('currentUser') private currentUserState: any;

    private email = '';
    private password = '';
    private firstName = '';
    private lastName = '';

    private usersRef = firebase.firestore().collection('users');

    private created(): void {
        this.getCurrentUserAction();
        this.email = this.currentUserState.email;
        this.firstName = this.currentUserState.firstName;
        this.lastName = this.currentUserState.lastName;
    }

    private submit(): void {
        if (this.password !== '') {
            firebase.auth().currentUser!!.updatePassword(this.password)
                .then(() => alert('Password changed successfully. Please use your new password next time you login.'))
                .catch((err) => alert('Could not update password: ' + err.message));
        }
    }
}
